var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-sparkline',{attrs:{"fill":_vm.fill,"gradient":_vm.gradientsValue,"line-width":_vm.width,"padding":_vm.padding,"smooth":_vm.radius || false,"value":_vm.value,"auto-draw":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }